/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PPLReviewExport
 */
export interface PPLReviewExport {
    /**
     * 
     * @type {string}
     * @memberof PPLReviewExport
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof PPLReviewExport
     */
    readonly s3Url?: string;
    /**
     * 
     * @type {Date}
     * @memberof PPLReviewExport
     */
    readonly dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PPLReviewExport
     */
    readonly dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof PPLReviewExport
     */
    s3Key: string;
    /**
     * 
     * @type {boolean}
     * @memberof PPLReviewExport
     */
    ready: boolean;
    /**
     * 
     * @type {number}
     * @memberof PPLReviewExport
     */
    user: number;
    /**
     * 
     * @type {string}
     * @memberof PPLReviewExport
     */
    task?: string | null;
}

/**
 * Check if a given object implements the PPLReviewExport interface.
 */
export function instanceOfPPLReviewExport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function PPLReviewExportFromJSON(json: any): PPLReviewExport {
    return PPLReviewExportFromJSONTyped(json, false);
}

export function PPLReviewExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): PPLReviewExport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        's3Url': !exists(json, 's3_url') ? undefined : json['s3_url'],
        'dateCreated': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'dateUpdated': !exists(json, 'date_updated') ? undefined : (new Date(json['date_updated'])),
        's3Key': json['s3_key'],
        'ready': json['ready'],
        'user': json['user'],
        'task': !exists(json, 'task') ? undefined : json['task'],
    };
}

export function PPLReviewExportToJSON(value?: PPLReviewExport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's3_key': value.s3Key,
        'ready': value.ready,
        'user': value.user,
        'task': value.task,
    };
}

